var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPmtPend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 0.500037C13.9706 0.500037 18 4.52948 18 9.50002C18 14.4706 13.9706 18.5 9.00002 18.5C4.02948 18.5 3.73308e-05 14.4706 3.73308e-05 9.50002C-0.014106 4.54357 3.99238 0.51418 8.94878 0.500037C8.96586 0.499988 8.98294 0.499988 9.00002 0.500037Z",
    fill: "#16A02C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2368_4818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.53893 4.28906C9.46752 4.31405 8.63201 4.79072 7.36268 5.52983L5.30247 6.72954H4.93471C4.73297 6.72954 4.51517 6.73846 4.4509 6.74917C4.14561 6.79738 3.8921 7.01161 3.79034 7.30975C3.75464 7.41151 3.75464 7.45793 3.75464 10.0591C3.75464 12.3603 3.75821 12.7156 3.78142 12.7941C3.86176 13.0619 4.08134 13.2815 4.34914 13.3618C4.42769 13.3851 4.89721 13.3886 8.11785 13.3886C12.099 13.3886 11.8509 13.394 12.0508 13.294C12.1615 13.2369 12.3186 13.0816 12.3811 12.9655C12.4704 12.8031 12.4846 12.7031 12.4846 12.2728C12.4846 11.8497 12.4793 11.8229 12.39 11.7569C12.34 11.7212 12.3168 11.7194 11.426 11.7087C10.644 11.6997 10.4976 11.6944 10.4101 11.6694C9.80494 11.4891 9.36219 11.0392 9.21401 10.4483C9.15867 10.2323 9.15867 9.87341 9.21401 9.66989C9.37647 9.07003 9.83529 8.61479 10.4334 8.45947C10.5762 8.42198 10.6297 8.41841 11.4563 8.41305C12.4097 8.40413 12.4043 8.40413 12.4579 8.30058C12.4971 8.22381 12.4971 7.49006 12.4561 7.3526C12.365 7.04374 12.1204 6.81523 11.8241 6.75989L11.7241 6.74025L11.1171 5.67979C10.4744 4.55507 10.4101 4.46045 10.2298 4.3569C10.0227 4.24086 9.75673 4.21408 9.53893 4.28906ZM9.98168 4.72288C10.0335 4.74788 10.0906 4.79072 10.1102 4.81929L10.1441 4.86749L8.54632 5.79941L6.94671 6.72954L6.56645 6.72597L6.18618 6.72061L7.87148 5.73871C8.79983 5.19777 9.59606 4.73895 9.64248 4.71753C9.75673 4.66218 9.86564 4.66397 9.98168 4.72288ZM10.9939 6.34749C11.1082 6.54922 11.1992 6.71704 11.1957 6.72239C11.1903 6.72597 10.8029 6.72775 10.3334 6.72597L9.48002 6.72061L10.112 6.35106C10.4601 6.14753 10.7529 5.9815 10.7636 5.97972C10.7743 5.97972 10.8779 6.14575 10.9939 6.34749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.12793,
    y: 7.6875,
    width: 4.35845,
    height: 4.875,
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7819 14.9788C13.3332 14.9788 14.5908 13.7212 14.5908 12.1699C14.5908 10.6186 13.3332 9.36099 11.7819 9.36099C10.2305 9.36099 8.97293 10.6186 8.97293 12.1699C8.97293 13.7212 10.2305 14.9788 11.7819 14.9788Z",
    fill: "white",
    stroke: "#16A02C",
    strokeWidth: 0.742856
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.784 10.3828V12.3328H13.0027",
    stroke: "#16A02C",
    strokeWidth: 0.557142
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2368_4818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.14061,
    height: 9.14062,
    fill: "white",
    transform: "translate(3.7547 4.24805)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmtPend);
export default __webpack_public_path__ + "static/media/pmt_pend.a3ae614db7d2bf5b017cf90bf4b067b7.svg";
export { ForwardRef as ReactComponent };